import styled, { keyframes } from 'styled-components';
import { BORDER_RADIUS, COLORS, FONT_SIZE } from '../Variables';

const slideIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(-100%);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const slideOut = keyframes`
    from {
        opacity: 1;
        transform: translateY(0);
    }
    to {
        opacity: 0;
        transform: translateY(1%);
    }
`;

export const Ribbon = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  top: -20px;
  left: -15px;
  background-color: ${(props) =>
    props.lang === 'hazteoir' ? COLORS.hoOrange : COLORS.cgoBlue};
  transform: skewX(-20deg);
  height: 30px;
  width: 60%;
  padding: 0 5px;
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 4px;
    border-color: transparent
      ${(props) =>
        props.lang === 'hazteoir'
          ? COLORS.hoDarkerOrange
          : COLORS.cgoDarkerBlue}
      transparent transparent;
    border-style: solid;
    border-width: 0 10px 20px 0;
    transform: skewX(20deg);
  }
  p {
    display: flex;
    align-items: center;
    justify-content: center;
    transform: skewX(20deg);
    color: ${COLORS.white};
    font-weight: 700;
    font-size: 11px;
    text-transform: uppercase;
  }
`;

export const LastFiveList = styled.ul`
  position: relative;
  display: flex;
  flex-direction: column;
  list-style: none;
  padding: 0 10px;
  margin-bottom: 25px;
  margin-left: 25px;
  border: 1px solid ${COLORS.lightGreyColor};
  border-radius: ${BORDER_RADIUS};
  width: 100%;
  background: linear-gradient(90deg, rgb(255, 255, 255) 0%, #f4f4f4 50%);
  box-shadow: 0 0 10px #00000019;
  li {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    &.signer-enter {
      opacity: 0;
      transform: translateY(-100%);
    }

    &.signer-enter-active {
      opacity: 1;
      transform: translateY(0);
      animation: ${slideIn} 0.5s forwards;
    }

    &.signer-exit {
      opacity: 1;
      transform: translateY(0);
    }

    &:not(:last-child)::after {
      position: absolute;
      content: '';
      width: 100%;
      height: 2px;
      background-image: linear-gradient(to right, #d8d8d8, transparent 90%);
      bottom: 0;
    }

    div {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 10px;
      width: 60%;
      img {
        width: 20px;
        height: auto;
        display: inline-block;
      }
      .user_box {
        .user_name {
          font-size: ${FONT_SIZE.small};
          overflow-wrap: break-word;
          text-align: left;
        }

        .user_country {
          color: #848484;
          font-size: ${FONT_SIZE.small};
          width: auto;
          overflow-wrap: break-word;
          margin-left: 5px;
        }
      }
    }
  }
  li.signer-exit-active {
      position: absolute;
      opacity: 0;
      transform: translateY(-100%);
      animation: ${slideOut} 0.1s forwards;
    }
`;
